
export interface TweetTags {
  hashtagIds?: string[];
}
